
import { defineComponent, ref, onMounted, computed } from "vue";
import envs from "../envs";
export default defineComponent({
  props: {
    base64: String,
    name: String,
  },
  setup(props) {
    const imageSrc = ref("");
    const name = ref("");

    onMounted(async () => {
      const url = `${envs.BACKEND_URL}/contact/${props.name}`;
      const res = await fetch(url);
      const content = await res.text();
      if (content.startsWith("cannot")) imageSrc.value = "failed";
      else imageSrc.value = res.url;
      if (props.name) name.value = props.name;
    });

    const downloadImage = () => {
      if (imageSrc.value != null) {
        let a = document.createElement("a");
        a.href = imageSrc.value;
        a.download = imageSrc.value;
        a.click();
      }
    };

    return {
      downloadImage,
      name,
      imageSrc,
    };
  },
});
